function exceedItemsCount(index, itemsCount) {
  return index > itemsCount - 1
}

function getNextItemIndexAfterNullOption(index, options) {
  return options.findIndex(
    (option, optionIndex) => optionIndex > index && Boolean(option)
  )
}

function getPreviousItemIndexAfterNullOption(index, options) {
  for (let i = index - 1; i >= 0; i -= 1) {
    if (options[i] !== null) {
      return i
    }
  }
}

function isNullOptionIndex(index, nullOptionsIndexes) {
  return Object.keys(nullOptionsIndexes).includes(index.toString())
}

export function getFocusedListItemNode(index, listRef) {
  return listRef.current.childNodes[index]
}

export function getHoveredListItemNodeIndex(target, listRef) {
  let hoveredListItemIndex

  for (const node of listRef.current.childNodes.entries()) {
    if (node[1].contains(target)) {
      hoveredListItemIndex = node[0]
      break
    }
  }

  return hoveredListItemIndex
}

export function getKeyDownArrowUpNextIndex({ nullOptionsIndexes, prevIndex }) {
  let nextIndex = Math.max((prevIndex || 0) - 1, 0)

  if (isNullOptionIndex(nextIndex, nullOptionsIndexes)) {
    const itemIndexAfterNull = nullOptionsIndexes[nextIndex].prev

    if (itemIndexAfterNull) {
      nextIndex = itemIndexAfterNull
    } else {
      nextIndex = prevIndex
    }
  }

  return nextIndex
}

export function getKeyDownArrowDownNextIndex({
  nullOptionsIndexes,
  optionsCount,
  prevIndex,
}) {
  let nextIndex = Number.isFinite(prevIndex)
    ? exceedItemsCount(prevIndex + 1, optionsCount)
      ? prevIndex
      : prevIndex + 1
    : 0

  if (isNullOptionIndex(nextIndex, nullOptionsIndexes)) {
    const itemIndexAfterNull = nullOptionsIndexes[nextIndex].next

    if (itemIndexAfterNull) {
      nextIndex = itemIndexAfterNull
    } else {
      nextIndex = prevIndex
    }
  }

  return nextIndex
}

export function getNullOptionsIndexes(options) {
  return options.reduce((acc, curVal, curIndex) => {
    if (curVal === null) {
      return {
        ...acc,
        [curIndex]: {
          next: getNextItemIndexAfterNullOption(curIndex, options),
          prev: getPreviousItemIndexAfterNullOption(curIndex, options),
        },
      }
    }

    return acc
  }, {})
}
